import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import { getServices } from '../services/api';
import { getIcon } from './Icons';

const SectionHeader = () => (
  <div className="section-header">
    <p className="section-eyebrow">What We Do</p>
    <h2 className="section-title">Our Services</h2>
    <div className="section-rule" aria-hidden="true"></div>
  </div>
);

const Services = () => {
  const { data: services, loading, error } = useFetch(getServices);

  return (
    <section className="services" id="services" aria-label="Our services">
      <div className="container">
        <SectionHeader />
        {loading && (
          <div className="services__loading">Loading services...</div>
        )}
        {error && (
          <div className="services__error">
            Unable to load services. Please try again later.
          </div>
        )}
        {services && (
          <div className="services__grid">
            {services.map((service) => {
              const IconComponent = getIcon(service.icon);
              return (
                <article key={service.id} className="service-card">
                  <div
                    className="service-card__accent"
                    aria-hidden="true"
                  ></div>
                  <div className="service-card__header">
                    {IconComponent && (
                      <IconComponent className="service-card__icon" />
                    )}
                    <h3 className="service-card__title">{service.title}</h3>
                  </div>

                  <p className="service-card__desc">{service.description}</p>
                  <Link to="/booking" className="service-card__link">
                    Get a Quote
                  </Link>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
